import { motion } from "framer-motion";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue
} from "@/components/ui/select"; // adjust path if needed
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchAllCategories } from "../store/categories/categoriesAction";

export default function FilterDropdown({
  currentCategory,
  setCurrentCategory
}) {
  const dispatch = useDispatch();
  const { allCategories, loading, loadingMore, filtering } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    dispatch(fetchAllCategories(currentCategory));
  }, [currentCategory]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="w-48"
    >
      <Select
        value={currentCategory}
        onValueChange={(value) => setCurrentCategory(value)}
        disabled={loading || loadingMore || filtering}
      >
        <SelectTrigger className="px-6 py-2 border rounded-md">
          <SelectValue placeholder="Filter" />
        </SelectTrigger>
        <SelectContent
          className="max-h-60 overflow-y-auto"
          position="popper"
          side="bottom"
        >
          <SelectItem value="all">All</SelectItem>

          {allCategories?.map((cat) => (
            <SelectItem value={cat.id} key={cat.id}>
              {cat.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </motion.div>
  );
}
